module.exports = __webpack_public_path__ + "static/media/delete.62d037d9.svg";